import { Action, combineReducers } from "redux";
import { ILogPage } from "source/models/log/logPage";

// State
export interface ILogPageState {
    dataId: number;
    logPage: ILogPage;
}

export interface ILogState {
    page: ILogPageState;
}

// Action type constants
const LOG_SUCCESS = "LOG_SUCCESS";
const LOG_FAILURE = "LOG_FAILURE";

type T_LOG_SUCCESS = typeof LOG_SUCCESS;
type T_LOG_FAILURE = typeof LOG_FAILURE;

// Action types
interface ILogSuccess extends Action {
    type: T_LOG_SUCCESS;
    logPage: ILogPage;
}

interface ILogFailure extends Action {
    type: T_LOG_FAILURE;
}

export type LogAction =
    | ILogSuccess
    | ILogFailure;

//Actions
export const logSuccess = (logPage: ILogPage): ILogSuccess => ({
    type: LOG_SUCCESS,
    logPage
});

export const logFailure = (): ILogFailure => ({
    type: LOG_FAILURE
});

///Reducers
export const logInitialState: ILogState = {
    page: {
        dataId: 0,
        logPage: null
    }
};

const page = (state: ILogPageState = null, action: LogAction) => {
    switch (action.type) {
    case LOG_SUCCESS: {
        const logSuccess = action as ILogSuccess;
        return {
            ...state,
            dataId: state.dataId + 1,
            logPage: logSuccess.logPage
        };
    }
    case LOG_FAILURE:
        return { ...state };
    }
    return state;
};

//Root reducer
export const logReducer = combineReducers({
    page
});

//Utils